import { defineMessages } from '@jutro/locale';

export default defineMessages({
    dueDateColumn: {
        id: 'ml.gateway.views.ActivityReports.MLContingenciesReport.DUE DATE',
        defaultMessage: 'DUE DATE'
    },
    dateAddedColumn: {
        id: 'ml.gateway.views.ActivityReports.MLContingenciesReport.DATE ADDED',
        defaultMessage: 'DATE ADDED'
    },
    customerNameColumn: {
        id: 'ml.gateway.views.ActivityReports.MLContingenciesReport.CUSTOMER NAME',
        defaultMessage: 'CUSTOMER NAME'
    },
    productColumn: {
        id: 'ml.gateway.views.ActivityReports.MLContingenciesReport.PRODUCT',
        defaultMessage: 'PRODUCT'
    },
    policyColumn: {
        id: 'ml.gateway.views.ActivityReports.MLContingenciesReport.POLICY #',
        defaultMessage: 'POLICY #'
    },
    potentialActionColumn: {
        id: 'ml.gateway.views.ActivityReports.MLContingenciesReport.POTENTIAL ACTION',
        defaultMessage: 'POTENTIAL ACTION'
    },
    description: {
        id: 'ml.gateway.views.ActivityReports.MLContingenciesReport.DESCRIPTION',
        defaultMessage: 'DESCRIPTION'
    },
    noContingenciesFound: {
        id: 'ml.gateway.views.ActivityReports.MLContingenciesReport.No recent outstanding contingencies found',
        defaultMessage: 'No recent outstanding contingencies found'
    },
    loading: {
        id: 'ml.gateway.views.ActivityReports.MLContingenciesReport.Loading...',
        defaultMessage: 'Loading...'
    },
    viewAllContingencies: {
        id: 'ml.gateway.views.ActivityReports.MLContingenciesReport.VIEW ALL CONTINGENCIES',
        defaultMessage: 'VIEW ALL CONTINGENCIES'
    },
    dueDateRange: {
        id: 'ml.gateway.views.ActivityReports.MLContingenciesReport.Due Date Range',
        defaultMessage: 'Due Date Range'
    },
    contingencies: {
        id: 'ml.gateway.views.ActivityReports.MLContingenciesReport.Contingencies',
        defaultMessage: 'Contingencies'
    }
});
